import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DecadenceData, DecadenceInitData, DecadenceGameData, WinData} from "./DecadenceData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Decadence} from "../Decadence";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {DEFAULT_ECDH_CURVE} from "tls";



export type ReelWithSymbol = {reelID:number, symbol:string}

export class DecadenceModel extends GameModel<DecadenceInitData, DecadenceGameData> {
    public wins:WinData[];
    public parsedReels:ReelWithSymbol[];
    public parsedEvaluatedArea:ReelWithSymbol[];
    public buyFeatureName:string;

    public isRestore:boolean;

    public get mode():GameMode {
        return this.data.mode;
    }
    public get nextMode():GameMode {
        return this.data.nextMode;
    }

    public get isFreeSpins():boolean {
        return this.mode.toString().includes("FREESPIN");
    }
    public get isSuperFreeSpins():boolean {
        return this.mode.toString().includes("FREESPIN_SUPER");
    }
    public get triggeredFreeSpins():boolean {
        return this.data.freespinsTriggeredThisSpin;
    }
    public get triggeredSuperFreeSpins():boolean {
        return this.data.mode != GameMode.FREESPIN_SUPER && this.data.nextMode == GameMode.FREESPIN_SUPER;
    }

    public get freeSpinsPlayed():number {
        return this.data.freespinsPlayed;
    }

    public get betPrice(): number {
        const betLevel: string = Decadence.apiPlugin.freeBets.hasFreeBets() ? Decadence.apiPlugin.freeBets.getBet() : Decadence.apiPlugin.betLevel.getLevel();
        let price: number = this.gameData?.playedBetValue || parseFloat(betLevel);
        if (this.data.wasFeatureBuy || this.isBoostedBet) {
            for (let index = 0; index < this.initData.featureBuyTimesBetValue.length; index++) {
                if (this.initData.featureBuyTimesBetValue[index].name === Decadence.apiPlugin.betFeatureController.getActiveBetFeature()?.name) {
                    price *= this.initData.featureBuyTimesBetValue[index].price;
                    price = MathHelper.roundToDecimals(price, 2);
                    break;
                }
            }
        }
        return price;
    }
    public get isBoostedBet():boolean {
        return this.isRestore ? this.initData.boostedBet : this.gameData.boostedBet;
    }
    public get spinWinnings():number {
        return this.gameData.totalSpinWinnings;
    }
    public get spinWinRatio():number {
        return (this.gameData.totalSpinWinnings / this.gameData.playedBetValue);
    }
    public get accumulatedWin():number {
        return this.gameData.accumulatedRoundWin;
    }
    public get winBelowStake():boolean {
        return Decadence.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.data.accumulatedRoundWin <= this.betPrice);
    }

    public get brokeTheBank():boolean {
        return this.data.brokeTheBank;
    }

    public get numberOfActiveReels():number {
        return this.parsedReels.length;
    }

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureBet", (data:boolean) => {
            this.isRestore = data;
        });
        api.events.once("featureName", (data:string) => {
            this.buyFeatureName = data;
        });

        Decadence.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < Decadence.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Decadence.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        })

    }

    protected onInit(data: DecadenceInitData) {
        super.onInit(data);
        this.isRestore = data.isRestoreState;
    }

    protected onGame(data: DecadenceGameData) {
        super.onGame(data);
        this.isRestore = false;
        this.setupReels();
        this.setupEvaluatedArea();
    }

    private setupReels():void {
        this.parsedReels = this.data.reels.map((sym, reelID) => {return {reelID:reelID, symbol:sym}});
    }

    private setupEvaluatedArea():void {
        this.parsedEvaluatedArea = this.gameData.evaluatedArea.map((sym, reelID) => {return {reelID:reelID, symbol:sym}});
    }
}